import { get } from '../tools/http';

export const colorsByType = {
    stage: '#ffd8eb',
    full_time: '#d0c5ff',
    webinar: '#9be3d3',
    past: '#e8e8e8',
    noty: '#ffeda9',
};

export function getColor(type, isPast, isSubscribed) {
    if (isSubscribed && !isPast) {
        return colorsByType.noty;
    } else if (!isSubscribed && isPast) {
        return colorsByType.past;
    }
    return colorsByType[type] ? colorsByType[type] : '';
}

function getAssembledEvents(events) {
    if (events && events.length) {
        return events.map(event => {
            return getAssembleEvent(event);
        });
    }
    return [];
}

function getAssembleEvent(event) {
    const result = { ...event };
    const isPast = isDatePast(event.datetimeEnd);
    const type = event.eventSubtype ? event.eventSubtype.type : null;
    const isSubscribed = event.userStatus === 'subscribed';
    result.title = event.name;
    result.eventId = event.id;
    result.start = event.datetimeBegin;
    result.end = event.datetimeEnd.replace('00:00:00', '23:59:59');
    result.color = getColor(type, isPast, isSubscribed);
    result.addressValue = event.address ? event.address.value : '';
    result.isPast = isPast;
    result.type = type;
    result.allDay = false;
    return result;
}

function isDatePast(date) {
    const now = new Date().getTime();
    const current = new Date(date).getTime();
    return current < now;
}

export default {
    namespaced: true,

    state: {
        events: [],
    },

    mutations: {
        writeEvents(state, events) {
            state.events = events;
        },
    },

    actions: {
        async getEvents({ commit }, params) {
            const answer = await get('event', 'event/all', params);
            if (answer) {
                const events = getAssembledEvents(answer.events);
                commit('writeEvents', events);
            }
        },

        flushEvents({ commit }) {
            commit('writeEvents', []);
        },
    },

    getters: {
        events: state => state.events,
    },
};
